export const isValidUrl = (str: string) => {
  try {
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
};

/** Returns hostname for display when URL is valid, otherwise the original string. */
export function getUrlDisplayName(url: string): string {
  try {
    return new URL(url).hostname;
  } catch {
    return url;
  }
}

export const isValidHttpsUrl = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === "https:";
  } catch (_) {
    return false;
  }
};
export const isTikTokUrl = (url: string) => {
  const tikTokRegex = /^(?:https?:\/\/)?(?:www\.)?tiktok\.com\/@[\w.-]+\/video\/\d+$/;
  return tikTokRegex.test(url);
};

export function isTweetUrl(url: string) {
  try {
    const parsedUrl = new URL(url);
    return (
      parsedUrl.hostname === "twitter.com" ||
      parsedUrl.hostname === "x.com" ||
      parsedUrl.hostname.endsWith(".twitter.com") ||
      parsedUrl.hostname.endsWith(".x.com")
    );
  } catch {
    return false;
  }
}

export function isVimeoUrl(url: string) {
  const pattern = /^https:\/\/vimeo\.com\/\d+$/;
  return pattern.test(url);
}

export function isYoutubeUrl(url: string) {
  try {
    const parsedUrl = new URL(url);
    return (
      parsedUrl.hostname === "youtube.com" ||
      parsedUrl.hostname === "www.youtube.com" ||
      parsedUrl.hostname === "youtu.be"
    );
  } catch {
    return false;
  }
}

export function isFacebookUrl(url: string) {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname === "facebook.com" || parsedUrl.hostname.endsWith(".facebook.com");
  } catch {
    return false;
  }
}
